export default __webpack_public_path__ + "static/media/Welcome.6a2cac00.png";